import React, { useRef, useCallback } from 'react';
import { SplitButtonGroup } from "./SplitButtonGroup.js";
import Button from "./Button.js";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "./modal/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A basic modal dialog with two buttons: cancel / confirm.
 *
 * @param isOpen indicates if the modal dialog is open
 * @param headerText text displayed in the modal header
 * @param bodyText text displayed in the modal body
 * @param onCancel callback for the cancel button; if not provided, button not shown
 * @param onConfirm callback for the confirm button
 * @param onDiscard callback for the discard button; if not provided, button not shown
 * @param cancelButtonText optional text for the cancel button, defaults to 'Cancel'
 * @param confirmButtonText optional text for the confirm button, defaults to 'Okay'
 * @param discardButtonText optional text for the discard button, defaults to 'Discard'
 */
function BasicModal(props) {
  var isOpen = props.isOpen,
    headerText = props.headerText,
    bodyText = props.bodyText,
    onCancel = props.onCancel,
    onConfirm = props.onConfirm,
    onDiscard = props.onDiscard,
    onModalDisable = props.onModalDisable,
    _props$cancelButtonTe = props.cancelButtonText,
    cancelButtonText = _props$cancelButtonTe === void 0 ? 'Cancel' : _props$cancelButtonTe,
    _props$confirmButtonT = props.confirmButtonText,
    confirmButtonText = _props$confirmButtonT === void 0 ? 'Okay' : _props$confirmButtonT,
    _props$discardButtonT = props.discardButtonText,
    discardButtonText = _props$discardButtonT === void 0 ? 'Discard' : _props$discardButtonT,
    _props$isConfirmDange = props.isConfirmDanger,
    isConfirmDanger = _props$isConfirmDange === void 0 ? false : _props$isConfirmDange,
    children = props.children,
    dataTestId = props['data-testid'];
  var confirmButton = useRef(null);
  var disableModalCheckbox = useRef(null);
  var onConfirmClicked = useCallback(() => {
    if (disableModalCheckbox.current !== null && disableModalCheckbox.current.checked && onModalDisable) {
      onModalDisable();
    }
    onConfirm();
  }, [onConfirm, onModalDisable]);
  var onOpened = useCallback(() => {
    var _confirmButton$curren;
    (_confirmButton$curren = confirmButton.current) === null || _confirmButton$curren === void 0 || _confirmButton$curren.focus();
  }, []);
  var modalBody = '';
  if (isOpen) {
    modalBody = typeof bodyText === 'function' ? bodyText() : bodyText;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onOpened: onOpened,
    children: [/*#__PURE__*/_jsx(ModalHeader, {
      closeButton: false,
      children: headerText
    }), /*#__PURE__*/_jsx(ModalBody, {
      children: modalBody
    }), /*#__PURE__*/_jsxs(ModalFooter, {
      children: [onModalDisable && /*#__PURE__*/_jsxs("div", {
        className: "custom-control custom-checkbox form-group mr-auto",
        children: [/*#__PURE__*/_jsx("input", {
          type: "checkbox",
          className: "custom-control-input",
          id: "move-confirmation-checkbox",
          defaultChecked: false,
          ref: disableModalCheckbox,
          "data-testid": dataTestId !== undefined ? "".concat(dataTestId, "-checkbox-confirm") : undefined
        }), /*#__PURE__*/_jsx("label", {
          className: "custom-control-label",
          htmlFor: "move-confirmation-checkbox",
          children: "Don't ask me again"
        })]
      }), onDiscard && /*#__PURE__*/_jsx(Button, {
        kind: "secondary",
        className: "mr-auto",
        "data-dismiss": "modal",
        onClick: onDiscard,
        "data-testid": dataTestId !== undefined ? "".concat(dataTestId, "-btn-discard") : undefined,
        children: discardButtonText
      }), onCancel && /*#__PURE__*/_jsx(Button, {
        kind: "secondary",
        "data-dismiss": "modal",
        onClick: onCancel,
        "data-testid": dataTestId !== undefined ? "".concat(dataTestId, "-btn-cancel") : undefined,
        children: cancelButtonText
      }), /*#__PURE__*/_jsxs(SplitButtonGroup, {
        children: [/*#__PURE__*/_jsx(Button, {
          kind: isConfirmDanger ? 'danger' : 'primary',
          onClick: onConfirmClicked,
          ref: confirmButton,
          "data-testid": dataTestId !== undefined ? "".concat(dataTestId, "-btn-confirm") : undefined,
          children: confirmButtonText
        }), children]
      })]
    })]
  });
}
export default BasicModal;
//# sourceMappingURL=BasicModal.js.map